import { render, staticRenderFns } from "./menuManagementAdd.vue?vue&type=template&id=64b3fb35&scoped=true&"
import script from "./menuManagementAdd.vue?vue&type=script&lang=js&"
export * from "./menuManagementAdd.vue?vue&type=script&lang=js&"
import style0 from "./menuManagementAdd.vue?vue&type=style&index=0&id=64b3fb35&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3fb35",
  null
  
)

export default component.exports